export class ShipmentSearchDTO{
  public status?:string
  public name?:string
  public invoice?:string
  public packing_type?:string
  public total_number?:string
  public total_net_weight?:string
  public total_gross_weight?:string
  public driver?:string
  public vehicle?:string
  public route?:string
  public dispatch_date?:string
  public expected_delivery_date?:string
}
